import React, { useEffect, useRef } from "react";

import { useTranslation } from "react-i18next";

import Logo from "../img/Logo.svg";
import LogoBlue from "../img/Logo-blue.svg";
import AmgenWhite from "../img/Amgen-white.svg";
import SupportTag from "../img/Support-tag.svg";
import Harvard from "../img/Harvard.svg";
import background from "../../images/background.svg";
import oldBackground from "../../images/old-background.svg";

import "./index.css";
import { usersnapLoadEmbededWidget } from "@labxchange/util-usersnap";

export default function EndScreen(props) {
  const { t } = useTranslation("translation");

  const usersnapContainerRef = useRef(null);
  const branding = props.sceneData.Scrolly.branding;

  useEffect(() => {
    if (usersnapContainerRef.current) {
      usersnapLoadEmbededWidget(usersnapContainerRef.current);
    }
  }, []);

  return (
    <div
      role="contentinfo"
      id="end-screen"
      className="end-screen"
      aria-hidden={props.ariaHideSplashScreens === "end" ? false : true}
      style={{
        backgroundImage: props.sceneData.Scrolly.background
          ? `url(${background})`
          : `url(${oldBackground})`,
      }}
      tabIndex={
        -1
      } /* Always use -1 to prevent tabbing directly to end screen */
    >
      {branding !== "" ? (
        <div className="end-branding">
          <img
            alt={t("supportLogo.string")}
            src={SupportTag}
            className="end-logo-support"
          />
          <img
            alt={t("amgenLogoAlt.string")}
            src={AmgenWhite}
            className="end-logo-2"
          />
          <div
            className="end-footer"
            style={{
              height:
                props.bp === "xl" || props.bp === "lg" || props.bp === "md"
                  ? null
                  : "30px",
            }}
          >
            <img
              alt={t("harvardLogoAlt.string")}
              src={Harvard}
              className="end-footer-logo"
              style={{
                marginLeft:
                  props.bp === "lg" || props.bp === "xl" ? "50px" : null,
              }}
            />
            <img
              alt={t("logoAlt.string")}
              src={LogoBlue}
              className="end-footer-logo"
            />
          </div>
        </div>
      ) : (
        <img alt={t("logoAlt.string")} src={Logo} className="end-logo" />
      )}
      {/* Conditionally render Usersnap widget only when fully visible to prevent tab index issues */}
      {props.lang === "en" && props.ariaHideSplashScreens === "end" && (
        <div
          className={`${props.bp === "lg" || props.bp === "xl" ? "usersnap-container-desktop" : "usersnap-container-mobile"}`}
          ref={usersnapContainerRef}
        ></div>
      )}
    </div>
  );
}
